var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'reflect-metadata';
import { Expose, Transform, Type } from 'class-transformer';
import moment from 'moment';
import { PLAN_TYPE } from '@logz-pkg/enums';
export class PlanDetailsModel {
    accountId;
    archivingSuspensionDailyLimitPctThreshold;
    backupEnabled;
    indexingSuspensionDailyLimitPctThreshold;
    maxAlertsDefinition;
    maxConcurrentQueriesApiUsers;
    maxConcurrentQueriesHumanUsers;
    maxKibanaBucketAggregations;
    maxKibanaFieldsNum;
    maxLiveTailSessions;
    maxLiveTailSessionsPerUser;
    maxS3BucketsNum;
    maxScrollHitsPerDayInMillions;
    maxSubAccounts;
    maxTimelessIndices;
    maxTimelessIndicesVolumeGb;
    maxUsersCount;
    planNotes;
    planType;
    totalVolumeGb;
    warningDailyLimitPctThreshold;
    queryApiRetentionDays;
    retentionDays;
    snapSearchRetentionDays;
    isApiAccessEnabled;
    isInsightsFeatureEnabled;
    maxDailyGb;
    // https://github.com/typestack/class-transformer#basic-usage
    startDate;
    endDate;
    isFlexible;
    isCapped;
    reservedDailyGb;
    totalTimeBasedDailyGb;
    isCommunityAccount() {
        return [PLAN_TYPE.FREE, PLAN_TYPE.TRIAL].includes(this.planType);
    }
}
__decorate([
    Expose({ name: 'apiAccessEnabled' }),
    __metadata("design:type", Boolean)
], PlanDetailsModel.prototype, "isApiAccessEnabled", void 0);
__decorate([
    Expose({ name: 'insightsFeatureEnabled' }),
    __metadata("design:type", Boolean)
], PlanDetailsModel.prototype, "isInsightsFeatureEnabled", void 0);
__decorate([
    Expose({ name: 'maxDailyGB' }),
    __metadata("design:type", Number)
], PlanDetailsModel.prototype, "maxDailyGb", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value), { toClassOnly: true }),
    __metadata("design:type", Object)
], PlanDetailsModel.prototype, "startDate", void 0);
__decorate([
    Type(() => Date),
    Transform(value => moment(value), { toClassOnly: true }),
    __metadata("design:type", Object)
], PlanDetailsModel.prototype, "endDate", void 0);
__decorate([
    Expose({ name: 'reservedDailyGB' }),
    __metadata("design:type", Number)
], PlanDetailsModel.prototype, "reservedDailyGb", void 0);
__decorate([
    Expose({ name: 'totalTimeBasedDailyGB' }),
    __metadata("design:type", Number)
], PlanDetailsModel.prototype, "totalTimeBasedDailyGb", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Boolean)
], PlanDetailsModel.prototype, "isCommunityAccount", null);
//# sourceMappingURL=plan-detail.js.map